import { formatBuildLabel } from '@gitextrade/shared';

// Values injected at build time by Vite (vite.config.ts `define`).
export const BUILD_DATE: string = __BUILD_DATE__;
export const LAST_PR: string = __LAST_PR__;
export const BUILD_LABEL: string = formatBuildLabel({ buildDate: BUILD_DATE, lastPr: LAST_PR });
